export const AI_PREVIEW_SPAN_CLASS = 'ai-rephrase-preview';
export const AI_PREVIEW_OLD_SPAN_CLASS = 'ai-rephrase-preview-old';

export const AI_HIGHLIGHT_CONTENT_STYLE = [
  `span.${AI_PREVIEW_OLD_SPAN_CLASS} { background-color: #fdeeee; color: #a4373a; text-decoration: line-through; padding: 1px 2px; border-radius: 2px; }`,
  `span.${AI_PREVIEW_OLD_SPAN_CLASS}::after { content: ' \\2192 '; color: #5a6872; text-decoration: none; }`,
  `span.${AI_PREVIEW_SPAN_CLASS} { background-color: #eaf6ec; border-bottom: 2px solid #2e7d32; padding: 1px 2px; border-radius: 2px; }`,
].join(' ');

export const AI_EXTENDED_VALID_ELEMENTS = 'span[style|class|data-ai-preview]';

export const AI_HINT_DISMISSED_KEY = 'ai-contextual-hint-dismissed';

export const AI_HINT_EXPIRY_HOURS = 24 * 30;
